export default "__VITE_ASSET__Cx4Ibitq__"